"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_redux_1 = require("react-redux");
const reducers_1 = require("../../reducers");
const getFormattedNumber_1 = require("../utils/getFormattedNumber");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const CampaignIcon_1 = require("./CampaignIcon");
const ListItemProgress_1 = require("./ListItemProgress");
const ListItemButtonGroup_1 = require("./ListItemButtonGroup");
const getCampaignType_1 = require("../utils/getCampaignType");
const TagListDisplay_1 = require("./TagListDisplay");
const CampaignListItem = ({ campaign, media, publishedCampaignStatus, pushToModal, }) => {
    const { id, status, trigger, name } = campaign;
    const handleClick = () => {
        if (status !== 'PUBLISHED') {
            return pushToModal('wizard');
        }
        if (trigger.__typename === 'CampaignAPITrigger') {
            return pushToModal('report');
        }
        if (['ACTIVE', 'EXPIRED', 'SENT'].includes(publishedCampaignStatus)) {
            return pushToModal('report');
        }
        return pushToModal('settings');
    };
    const style = {
        width: '100%',
        height: 95,
        backgroundColor: 'white',
        flex: '0 0 auto',
        borderBottom: `1px solid ${src_1.titanium}`,
    };
    const renderStat = (value, description) => (React.createElement("div", { style: {
            width: 144,
            flex: 'none',
            display: 'flex',
            flexDirection: 'column',
        } },
        React.createElement(src_1.Text, { size: "large", text: getFormattedNumber_1.default(value), textStyle: { color: src_1.charcoal } }),
        React.createElement(src_1.Text, { size: "small", label: true, text: description, textStyle: { color: src_1.charcoal } })));
    const shouldRenderStat = () => {
        if (getCampaignType_1.isScheduledCampaignTrigger(campaign.trigger)) {
            return publishedCampaignStatus === 'SENT';
        }
        if (getCampaignType_1.isAutomatedCampaignTrigger(campaign.trigger)) {
            return ['ACTIVE', 'EXPIRED'].includes(publishedCampaignStatus);
        }
        if (getCampaignType_1.isAPICampaignTrigger(campaign.trigger)) {
            return campaign.status === 'PUBLISHED';
        }
    };
    return (React.createElement("div", { onClick: handleClick, style: style },
        React.createElement("div", { style: {
                display: 'grid',
                alignItems: 'center',
                height: '100%',
                maxWidth: media === 'Desktop' ? 1024 : 1024,
                margin: 'auto',
                paddingLeft: media === 'Desktop' ? 32 : 0,
                paddingRight: media === 'Desktop' ? 32 : 0,
                gridTemplateColumns: 'auto 45% 25% 1fr',
            } },
            React.createElement(CampaignIcon_1.default, { status: status, type: trigger.__typename }),
            React.createElement("div", { style: { flex: '1 1 auto' } },
                React.createElement(src_1.Text, { text: name, size: "large" }),
                React.createElement(ListItemProgress_1.default, { campaign: campaign, media: media })),
            React.createElement("div", { style: {
                    flex: '1 1 auto',
                } },
                React.createElement(TagListDisplay_1.default, { tags: campaign.tags })),
            React.createElement("div", { style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifySelf: 'end',
                } },
                shouldRenderStat() &&
                    media !== 'Mobile' &&
                    renderStat(campaign.stats && campaign.stats.totalDelivered ? campaign.stats.totalDelivered : 0, 'Delivered'),
                shouldRenderStat() &&
                    media === 'Desktop' &&
                    renderStat(campaign.stats && campaign.stats.uniqueOpened ? campaign.stats.uniqueOpened : 0, 'Opened'),
                media === 'Desktop' ? (React.createElement(ListItemButtonGroup_1.default, { id: id, pushToModal: pushToModal })) : (React.createElement(src_1.ChevronRightIcon, { fill: src_1.titanium }))))));
};
const mapStateToProps = (state, ownProps) => {
    const { campaign: { id }, } = ownProps;
    return {
        publishedCampaignStatus: reducers_1.getPublishedCampaignLifecycleStatus(state, id),
    };
};
exports.default = react_redux_1.connect(mapStateToProps, {})(React.memo(CampaignListItem));
